import { render, staticRenderFns } from "./replacementorder.vue?vue&type=template&id=f2c60486"
import script from "./replacementorder.vue?vue&type=script&lang=js"
export * from "./replacementorder.vue?vue&type=script&lang=js"
import style0 from "./replacementorder.vue?vue&type=style&index=0&id=f2c60486&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports